function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Button, Divider, HStack, Icon, Link, ListItem, Stack, Text, UnorderedList, VStack } from '@chakra-ui/react';
import React from 'react';
import LogoText from '@/components/LogoText';
import useAuthenticationStore from '@/stores/AuthenticationStore';
import { useSearchParams } from 'react-router';
import { authorizeOAuth2Application, getOAuth2Application, getOAuth2Scopes } from '@/actions/AuthActions';
import { logoutUser } from '@/actions/UserActions';
import { faTriangleExclamation, faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage, useIntl } from 'react-intl';
import Panel from '../Panel';
import CenteredLayout from '../layouts/CenteredLayout';
import { Helmet } from 'react-helmet';
import Notice from '../Notice';
import { ExternalUrls, WebRoutes } from '@/utils/constants';
import useBackButton from '@/hooks/useBackButton';
var DEFAULT_SCOPE = 'basic user information';
export default function OAuth2() {
    var intl = useIntl();
    var user = useAuthenticationStore(function(state) {
        return state.user;
    });
    var _useSearchParams = _sliced_to_array(useSearchParams(), 1), params = _useSearchParams[0];
    var _React_useState = _sliced_to_array(React.useState(null), 2), application = _React_useState[0], setApplication = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState(null), 2), appHostname = _React_useState1[0], setAppHostname = _React_useState1[1];
    var _React_useState2 = _sliced_to_array(React.useState(null), 2), applicationError = _React_useState2[0], setApplicationError = _React_useState2[1];
    var _React_useState3 = _sliced_to_array(React.useState(null), 2), authError = _React_useState3[0], setAuthError = _React_useState3[1];
    var _React_useState4 = _sliced_to_array(React.useState([]), 2), scopeDescriptions = _React_useState4[0], setScopeDescriptions = _React_useState4[1];
    var back = useBackButton(WebRoutes.DASHBOARD).back;
    React.useEffect(function() {
        var clientId = params.get('client_id');
        var scopeParam = params.get('scope');
        var redirectUri = params.get('redirect_uri');
        var responseType = params.get('response_type');
        if (clientId == null || redirectUri == null || responseType == null) {
            setApplicationError(intl.formatMessage({
                id: "kdLMyb",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Invalid OAuth2 request."
                    }
                ]
            }));
            return;
        }
        var hostname = null;
        try {
            hostname = new URL(redirectUri).hostname;
        } catch (error) {}
        var requestedScopes = scopeParam != null ? scopeParam.split(' ') : [];
        if (hostname != null && hostname.toLowerCase() !== 'localhost') {
            setAppHostname(hostname);
        }
        getOAuth2Application(clientId).then(function(application) {
            return setApplication(application);
        }).catch(function() {
            return setApplicationError(intl.formatMessage({
                id: "M89Bw1",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Failed to fetch OAuth2 application."
                    }
                ]
            }));
        });
        if (requestedScopes.length === 0) {
            setScopeDescriptions([
                DEFAULT_SCOPE
            ]);
            return;
        }
        getOAuth2Scopes().then(function(scopes) {
            var descriptions = requestedScopes.map(function(scope) {
                var _scopes_scope;
                return (_scopes_scope = scopes[scope]) !== null && _scopes_scope !== void 0 ? _scopes_scope : null;
            });
            if (descriptions.some(function(description) {
                return description == null;
            })) {
                setApplicationError(intl.formatMessage({
                    id: "H3S8uD",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Invalid OAuth2 scopes."
                        }
                    ]
                }));
                return;
            }
            setScopeDescriptions(descriptions);
        });
    }, [
        intl,
        params
    ]);
    var handleAllow = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(allow) {
            var clientId, scopeParam, redirectUri, responseType, state, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        clientId = params.get('client_id');
                        scopeParam = params.get('scope');
                        redirectUri = params.get('redirect_uri');
                        responseType = params.get('response_type');
                        state = params.get('state');
                        if (clientId == null || redirectUri == null || responseType == null) {
                            setApplicationError(intl.formatMessage({
                                id: "kdLMyb",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Invalid OAuth2 request."
                                    }
                                ]
                            }));
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            authorizeOAuth2Application(allow, {
                                client_id: clientId,
                                redirect_uri: redirectUri,
                                response_type: responseType,
                                scope: scopeParam !== null && scopeParam !== void 0 ? scopeParam : undefined,
                                state: state !== null && state !== void 0 ? state : undefined
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (_instanceof(error, Error)) {
                            setAuthError(error.message);
                        } else {
                            setAuthError(intl.formatMessage({
                                id: "cxp1iJ",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Failed to authorize application."
                                    }
                                ]
                            }));
                        }
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(allow) {
            return _ref.apply(this, arguments);
        };
    }(), [
        intl,
        params
    ]);
    if (applicationError != null) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Helmet, {
                    title: intl.formatMessage({
                        id: "lv9CcZ",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Application Error"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Notice, {
                    beforeElement: /*#__PURE__*/ _jsx(Icon, {
                        size: "2xl",
                        as: FontAwesomeIcon,
                        icon: faWarning,
                        color: "intermediate"
                    }),
                    heading: intl.formatMessage({
                        id: "lv9CcZ",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Application Error"
                            }
                        ]
                    }),
                    description: applicationError,
                    buttons: [
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "link",
                            as: Link,
                            href: ExternalUrls.NIGHTDEV_EMAIL,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "YdQxfw",
                                defaultMessage: "Contact Support"
                            })
                        }, "support-button"),
                        /*#__PURE__*/ _jsx(Button, {
                            onClick: back,
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "cyR7Kh",
                                defaultMessage: "Back"
                            })
                        }, "go-back-button")
                    ]
                })
            ]
        });
    }
    if (user == null || application == null || scopeDescriptions.length === 0) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Helmet, {
                    title: intl.formatMessage({
                        id: "3SWvft",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Authorize Application"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Notice, {
                    heading: intl.formatMessage({
                        id: "ZW2Pzc",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "Loading Application"
                            }
                        ]
                    }),
                    description: intl.formatMessage({
                        id: "uowRF5",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "You will be redirected shortly."
                            }
                        ]
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(CenteredLayout, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "3SWvft",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Authorize Application"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Panel, {
                padding: 0,
                as: Stack,
                gap: 0,
                maxWidth: "400px",
                children: [
                    /*#__PURE__*/ _jsxs(VStack, {
                        spacing: 0,
                        gap: 0,
                        p: 6,
                        children: [
                            /*#__PURE__*/ _jsx(LogoText, {}),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "sm",
                                color: "textSecondary",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "3SWvft",
                                    defaultMessage: "Authorize Application"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Divider, {}),
                    /*#__PURE__*/ _jsxs(Stack, {
                        spacing: 4,
                        p: 6,
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "sm",
                                textAlign: "center",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "xCHoid",
                                    defaultMessage: "Authorize {applicationName} to access your Nightbot account.",
                                    values: {
                                        applicationName: appHostname != null ? "".concat(application.name, " (").concat(appHostname, ")") : application.name
                                    }
                                })
                            }),
                            /*#__PURE__*/ _jsxs(HStack, {
                                alignItems: "center",
                                gap: 2,
                                alignSelf: "center",
                                children: [
                                    /*#__PURE__*/ _jsx(Avatar, {
                                        size: "md",
                                        name: user.displayName,
                                        src: user.avatar
                                    }),
                                    /*#__PURE__*/ _jsxs(Stack, {
                                        gap: 0,
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                fontSize: "sm",
                                                children: user.displayName
                                            }),
                                            /*#__PURE__*/ _jsx(Button, {
                                                fontWeight: "sm",
                                                size: "xs",
                                                variant: "link",
                                                color: "textSecondary",
                                                onClick: logoutUser,
                                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                                    id: "WTpGO4",
                                                    defaultMessage: "Not you?"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Divider, {}),
                    /*#__PURE__*/ _jsxs(Stack, {
                        spacing: 4,
                        p: 6,
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "sm",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "ZUxu6o",
                                    defaultMessage: "Clicking Allow below will authorize {applicationName} to:",
                                    values: {
                                        applicationName: application.name
                                    }
                                })
                            }),
                            /*#__PURE__*/ _jsx(UnorderedList, {
                                children: scopeDescriptions.map(function(description) {
                                    return /*#__PURE__*/ _jsx(ListItem, {
                                        fontSize: "sm",
                                        color: "textSecondary",
                                        children: description
                                    }, description);
                                })
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                fontSize: "sm",
                                color: "textSecondary",
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "PWWbNE",
                                    defaultMessage: "You can revoke access to {applicationName} at any time from your Nightbot account area.",
                                    values: {
                                        applicationName: application.name
                                    }
                                })
                            })
                        ]
                    }),
                    authError != null ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Divider, {}),
                            /*#__PURE__*/ _jsxs(HStack, {
                                color: "red",
                                gap: 2,
                                padding: 6,
                                children: [
                                    /*#__PURE__*/ _jsx(Icon, {
                                        as: FontAwesomeIcon,
                                        icon: faTriangleExclamation
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontSize: "sm",
                                        children: authError
                                    })
                                ]
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx(Divider, {}),
                    /*#__PURE__*/ _jsxs(HStack, {
                        alignSelf: "center",
                        spacing: 6,
                        p: 6,
                        width: "100%",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                flex: 1,
                                size: "sm",
                                onClick: function() {
                                    return handleAllow(false);
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "htvX+Z",
                                    defaultMessage: "Deny"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                flex: 1,
                                size: "sm",
                                variant: "cta",
                                onClick: function() {
                                    return handleAllow(true);
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "y/bmsG",
                                    defaultMessage: "Allow"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
